module.exports = __webpack_public_path__ + "static/media/mobile-animation.79d94271.gif";